module.exports = __webpack_public_path__ + "static/media/icon-6.7910290b.png";